/* Atelier Noir — before/after compare slider. Drag anywhere to paint; the
   native range drives keyboard + AT. Position lives in the --pos custom
   property (rAF-coalesced); double-click eases to the tapped point. */
(() => {
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (n) => (n < 0 ? 0 : n > 100 ? 100 : n);

  class CompareSlider extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.compare__range');
      if (!this.range) return;
      this.range.addEventListener('input', () => this.set(+this.range.value));
      this.addEventListener('pointerdown', this.down.bind(this));
      this.addEventListener('pointermove', this.move.bind(this));
      this.addEventListener('pointerup', this.up.bind(this));
      this.addEventListener('pointercancel', this.up.bind(this));
      this.addEventListener('dblclick', this.jump.bind(this));
    }

    down(e) {
      this.setPointerCapture(e.pointerId);
      this._x = e.clientX;
      this._drag = false;
      this.range.focus();
    }

    move(e) {
      if (!this.hasPointerCapture(e.pointerId)) return;
      if (!this._drag && Math.abs(e.clientX - this._x) < 4) return;
      this._drag = true;
      const p = this.pct(e.clientX);
      this.range.value = p;
      this.set(p);
    }

    up(e) {
      try {
        this.releasePointerCapture(e.pointerId);
      } catch (_) {}
      this._drag = false;
    }

    pct(x) {
      const r = this.getBoundingClientRect();
      return clamp(((x - r.left) / r.width) * 100);
    }

    set(v) {
      this._p = v;
      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = 0;
        this.style.setProperty('--pos', this._p + '%');
      });
    }

    jump(e) {
      const to = this.pct(e.clientX);
      if (RM.matches) {
        this.range.value = to;
        this.set(to);
        return;
      }
      const from = +this.range.value || 0;
      const t0 = performance.now();
      const step = (now) => {
        const k = Math.min(1, (now - t0) / 200);
        const p = from + (to - from) * (1 - Math.pow(1 - k, 3));
        this.range.value = p;
        this.style.setProperty('--pos', p + '%');
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('compare-slider')) customElements.define('compare-slider', CompareSlider);
})();
